import { jwtDecode } from 'jwt-decode';

export const handleEnter = (
  event: React.KeyboardEvent<HTMLInputElement>, // change to synthetic event
  callback: () => any
) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    callback();
  }
};

export const focusInput = (inputRef: React.MutableRefObject<any>) => {
  if (!inputRef) return;

  inputRef.current?.focus();
};

export const getServerErrorMessage = (err: any) =>
  err.response?.data?.message ?? err.response?.data?.status;

export const getWindowOrigin = () => {
  if (typeof window === 'undefined') return '';

  return window.location.origin;
};
export const getWindowHref = () => {
  if (typeof window === 'undefined') return '';

  return window.location.href;
};

export const isTokenExpired = (token: string) => {
  try {
    const decoded = jwtDecode(token);

    const currentTime = Math.floor(Date.now() / 1000);

    return decoded.exp ? decoded.exp < currentTime : true;
  } catch (error) {
    return true;
  }
};
